module.exports = __webpack_public_path__ + "img/WE_blog1.b70079e9.png";